<script setup lang="ts">
import { RouterView } from 'vue-router'
import AppLayout from "@/layouts/AppLayout.vue";
import TheSnackbar from "@/components/TheSnackbar.vue";
import ContentClipboardIndicator from "@/modules/content/components/ContentClipboardIndicator.vue";
</script>

<template>
<v-app>
  <AppLayout>
    <suspense>
      <RouterView />
    </suspense>
  </AppLayout>
  <TheSnackbar />
  <ContentClipboardIndicator />
</v-app>
</template>
